import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function ProcessButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      Process Notifications
    </Button>
  );
}
